import { Link } from "react-router"
import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden -mt-16 bg-[url('/background.jpg')] bg-cover bg-center bg-no-repeat">
      {/* Layered overlays for depth */}
      {/* <div className="absolute inset-0 bg-[#0D0D0D]/60" /> */}
      <div className="absolute inset-0 bg-[linear-gradient(to_top,#0D0D0D_0%,transparent_50%)]" />
      {/* <div className="absolute inset-0 bg-[linear-gradient(to_bottom,#0D0D0D/30_0%,transparent_30%)]" /> */}

      {/* Left green edge accent */}
      <div className="absolute left-0 top-1/4 bottom-1/4 w-0.75 bg-[#1D591B]" />

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 pt-56 pb-36 sm:pt-64 sm:pb-44">
        <div className="mx-auto max-w-4xl text-center">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black tracking-tight text-foreground text-balance mb-8 leading-[1.05]">
            {"AI-powered intelligence for "}
            <span className="text-primary">renewable energy</span>
            {" investments"}
          </h1>

          <p className="text-base sm:text-lg text-white/90 text-balance mb-12 leading-relaxed max-w-2xl mx-auto">
            Navigate the UK's 125 GW connection queue with confidence.<br/>
            The industry's first platform to combine data aggregation,
            AI querying, project viability and developer credibility scoring.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <Button
              size="lg"
              className="bg-white text-foreground hover:bg-primary/90 hover:text-white/90 font-semibold px-8 md:min-w-60 h-12 text-base border-0 shadow-none rounded-lg transition-all duration-200"
              asChild
            >
              <Link to="/waitlist">
                Join Waitlist <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="text-white px-8 bg-transparent md:min-w-60 h-12 text-base border border-white/25 hover:bg-white/8 hover:border-white/40 rounded-lg shadow-none transition-all duration-200"
              asChild
            >
              <a href="#demo">
                Interactive Demo
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
